import {Component} from 'react';
import h from 'react-hyperscript';
import './ProgramAdvancement.scss';
import BasicCard from 'Components/Cards/BasicCard';
import {h4, eyebrow, footnote} from 'Components/Typography/Typography';
import ProgressBar from 'Components/DataViz/ProgressBar/ProgressBar';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import {
  setZeroIfInvalidNumber,
  isArrayEmpty,
  getPercentageDifference,
  getPercentValue,
} from 'Src/utils/utils';
import ReportError from 'Components/ErrorMessage/ReportError';
import Benchmarking from 'Components/Benchmarking/Benchmarking';

class ProgramAdvancement extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      num_l1s_district: 0,
      num_l2s_district: 0,
      totalTeachers: 0,
      isLoaded: false,
      hasError: false,
    };
  }

  componentWillMount() {
    this._isMounted = true;
    this.setData();
  }

  setData() {
    if (this.dataAvailable) {
      this.createGraphs();
    } else {
      this.setHasError(true);
    }
  }

  get dataAvailable() {
    return !isArrayEmpty(this.props.graphs);
  }

  setHasError(value) {
    this.setState({
      isLoaded: true,
      hasError: value,
    });
  }

  createGraphs() {
    this.props.graphs.forEach((graph, i) => {
      const value = setZeroIfInvalidNumber(this.props.data[graph.id]);
      this.setGraph(graph.id, value);

      if (this.props.dataPrev) {
        const valuePrev = setZeroIfInvalidNumber(this.props.dataPrev[graph.id]);
        this.setGraph(graph.id + 'Prev', valuePrev);
      }
    });
  }

  setGraph(id, value) {
    if (this._isMounted) {
      this.setState(
          {
            [id]: value,
          },
          () => {
            this.setState({
              isLoaded: true,
            });
          }
      );
    }
  }

  createGraphHeader(graph) {
    return h(
        eyebrow,
        {
          key: `program-advancement-eyebrow`,
        },
        graph.title
    );
  }

  render() {
    if (this.state.isLoaded) {
      return h(
          BasicCard,
          {
            id: this.props.id,
            className: this.props.className,
          },
          [
            h(
                TooltipGroup,
                {
                  title: this.props.tooltip,
                  placement: 'top-end',
                },
                h(
                    h4,
                    {
                      key: `title__key`,
                      className: 'card__title',
                    },
                    this.props.title
                )
            ),
          this.state.hasError ?
            h(
                ReportError,
                {
                  message: this.props.noDataError,
                },
                null
            ) :
            h(
                'div',
                {
                  key: 'graphs__key',
                },
                this.props.graphs.map((graph, i) => {
                  const id = graph.id;
                  const value = this.state[id];
                  const teachers = this.props.districtMetrics[`num_teachers`];
                  const percentage = setZeroIfInvalidNumber(value / teachers);

                  const progressComponents = [
                    h(
                        ProgressBar,
                        {
                          key: `${id}__key`,
                          id: `${id}`,
                          value: percentage,
                          height: 8,
                          width: 150,
                          color: graph.color,
                        },
                        null
                    ),
                    h(
                        h4,
                        {
                          className: 'padding-left--md-2',
                        },
                        `${getPercentValue(percentage)}%`
                    ),
                  ];

                  const valuePrev = this.state[id + 'Prev'];

                  if (!isNaN(valuePrev)) {
                    const teachersPrev = this.props.districtMetricsPrev[
                        `num_teachers`
                    ];
                    const percentagePrev = setZeroIfInvalidNumber(
                        valuePrev / teachersPrev
                    );
                    const change = getPercentageDifference(
                        percentage,
                        percentagePrev
                    );

                    progressComponents.push(
                        h(Benchmarking, {
                          change,
                          className:
                          'padding-left--micro padding-bottom--micro-2',
                        })
                    );
                  }

                  return h(
                      'div',
                      {
                        key: `${id}-graph__key`,
                        className: 'program-advancement__metric',
                      },
                      [
                        h('div', {}, [
                          this.createGraphHeader(graph),
                          h(
                              footnote,
                              {
                                key: `program-advancement-footnote`,
                                className: 'text--grey',
                              },
                              `${value} Teachers Certified`
                          ),
                        ]),
                        h(
                            'div',
                            {
                              className: 'flex--space-between--all',
                            },
                            progressComponents
                        ),
                      ]
                  );
                })
            ),
          ]
      );
    } else {
      return h(LoadingIndicator, null, null);
    }
  }
}

export default ProgramAdvancement;
